import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';

export default class ValidatorSingle extends Validator implements ValidatorInterface {

    /**
     * Check if value is valid
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        this.checkInteger(value,index);

        let maxValue = this.dataVariable.options ? this.dataVariable.options.length : 1;
        let integerValue = Number.parseInt(value,10);

        if (integerValue<1 || integerValue>maxValue) {
            this.addError("Invalid value found. Valid range is between 1 and "+maxValue, index, value);
            return false;
        }

        return true;
    }
}
